import { $t } from "@/plugins/i18n"
import { getInitials as getInitialsHelper } from "@/utils/helpers"

import { Notification } from "./Notification"

export class NotificationComment extends Notification {
  constructor(props) {
    super(props)
  }

  get isEpic() {
    return Boolean(
      this.content.epicSequenceNumber ||
        this.content.itemUrl?.includes("/epic/") ||
        this.content.targetUrl?.includes("/epic/")
    )
  }

  /**
   * A reply reuses `itemSequenceNumber` for the idea number, so `/ideas/…?idea=` in the url is the
   * only marker that separates it from a real Item.
   */
  get isIdea() {
    return Boolean(
      this.content.ideaSequenceNumber != null ||
        this.content.ideaUrl ||
        this.content.itemUrl?.includes("?idea=") ||
        this.content.resourceUrl?.includes("?idea=")
    )
  }

  get ideaSequenceNumber() {
    return this.content.ideaSequenceNumber ?? this.content.itemSequenceNumber
  }

  get itemLabel() {
    if (this.isIdea) {
      return `Idea I-${this.ideaSequenceNumber}`
    }

    if (this.isEpic) {
      const n = this.content.epicSequenceNumber ?? this.content.itemSequenceNumber
      return `Epic E-${n}`
    }

    return `Item #${this.content.itemSequenceNumber}`
  }

  get itemHref() {
    return (
      this.content?.itemUrl ||
      this.content?.targetUrl ||
      this.content?.epicUrl ||
      this.content?.ideaUrl ||
      "#"
    )
  }

  get initiator() {
    return this.content?.initiator ?? this.content?.initiators?.[0]
  }

  get initiatorAvatarSrc() {
    const initiator = this.initiator
    if (!initiator) return ""

    return initiator.picture?.pictureUrl ?? ""
  }

  get initiatorFullName() {
    if (!this.initiator) return ""
    return this.initiator.firstName + " " + this.initiator.lastName
  }

  get itemSequenceNumber() {
    return `#${this.content?.itemSequenceNumber ?? $t("none")}`
  }

  get epicSequenceNumber() {
    return this.content?.epicSequenceNumber != null ? `E-${this.content.epicSequenceNumber}` : ""
  }

  get epicName() {
    return this.content?.epicName
  }

  get epicUrl() {
    return this.content?.epicUrl
  }

  get displaySequenceNumber() {
    if (this.isIdea) {
      return `Idea I-${this.ideaSequenceNumber}`
    }

    if (this.content?.itemSequenceNumber != null) {
      return `Item #${this.content.itemSequenceNumber}`
    }

    if (this.content?.epicSequenceNumber != null) {
      return `Epic E-${this.content.epicSequenceNumber}`
    }

    return $t("none")
  }

  get reactionType() {
    return this.content?.reactionType
  }

  get message() {
    return this.content?.message
  }

  get itemUrl() {
    return this.content?.itemUrl
  }

  get comment() {
    return this.content?.content
  }

  get commentId() {
    return this.content?.commentId ?? this.content?.comment?.id ?? ""
  }

  get demoVideoTimestamp() {
    return this.content?.demoVideoTimestamp ?? null
  }

  get demoVideoId() {
    return this.content?.demoVideoId ?? ""
  }

  get repliedOnComment() {
    return this.content?.repliedOnComment
  }

  get fromAi() {
    return this.content?.fromAi
  }

  get text() {
    return this.content?.text
  }

  get attachments() {
    return this.content?.attachmentsMetadata?.attachments || []
  }

  get attachmentsCount() {
    return this.content?.attachmentsMetadata.attachmentsCount ?? 0
  }

  get resourceUrl() {
    return this.content?.resourceUrl || ""
  }

  getInitials() {
    return getInitialsHelper(this.initiatorFullName)
  }
}
